import { useFormContext } from "react-hook-form";
import { IParcelasCustasRequest } from "../../../../Interfaces/Geral/LancamentoCustas/LancamentoCustasInterface";

export function TipodeCustas() {
    const formLancamentoCusta = useFormContext<IParcelasCustasRequest>();
    const { register } = formLancamentoCusta;

    return (
        <>
            <h3 className="mt-5">Tipos de Custas</h3>
            <div className="d-flex flex-wrap align-items-end mt-6">
                <div className="col-12 col-sm-4 col-md-2">
                    <div className="d-flex align-items-center justify-content-center">
                        <span>Juros atraso</span>
                    </div>
                    <span
                        className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-1"
                        data-toggle="tooltip"
                    >
                        <label>
                            <input
                                name="FlCobrarJurosAtraso"
                                type="checkbox"
                                defaultChecked={false}
                                ref={register()}
                            />
                            <span></span>
                        </label>
                    </span>
                </div>
                <div className="col-12 col-sm-4 col-md-2">
                    <div className="d-flex align-items-center justify-content-center">
                        <span>Multa atraso</span>
                    </div>
                    <span
                        className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-1"
                        data-toggle="tooltip"
                    >
                        <label>
                            <input
                                name="FlCobrarMulta"
                                type="checkbox"
                                defaultChecked={false}
                                ref={register()}
                            />
                            <span></span>
                        </label>
                    </span>
                </div>
                <div className="col-12 col-sm-4 col-md-2">
                    <div className="d-flex align-items-center justify-content-center">
                        <span>Correção</span>
                    </div>
                    <span
                        className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-1"
                        data-toggle="tooltip"
                    >
                        <label>
                            <input
                                name="FlCobrarCorrecao"
                                type="checkbox"
                                defaultChecked={false}
                                ref={register()}
                            />
                            <span></span>
                        </label>
                    </span>
                </div>
                <div className="col-12 col-sm-4 col-md-2">
                    <div className="d-flex align-items-center justify-content-center">
                        <span>Imposto</span>
                    </div>
                    <span
                        className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-1"
                        data-toggle="tooltip"
                    >
                        <label>
                            <input
                                name="FlCobrarImposto"
                                type="checkbox"
                                defaultChecked={false}
                                ref={register()}
                            />
                            <span></span>
                        </label>
                    </span>
                </div>
                <div className="col-12 col-sm-4 col-md-2">
                    <div className="d-flex align-items-center justify-content-center">
                        <span>Rep. Locador</span>
                    </div>
                    <span
                        className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-1"
                        data-toggle="tooltip"
                    >
                        <label>
                            <input
                                name="FlCobrarRepasseLocador"
                                type="checkbox"
                                defaultChecked={false}
                                ref={register()}
                            />
                            <span></span>
                        </label>
                    </span>
                </div>
                <div className="col-12 col-sm-4 col-md-2">
                    <div className="d-flex align-items-center justify-content-center">
                        <span>Tx. administração</span>
                    </div>
                    <span
                        className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-1"
                        data-toggle="tooltip"
                    >
                        <label>
                            <input
                                name="FlCobrarTxAdm"
                                type="checkbox"
                                defaultChecked={false}
                                ref={register()}
                            />
                            <span></span>
                        </label>
                    </span>
                </div>
            </div>
        </>
    );
}
